__turbopack_context__.v({
  "burger": "HeaderBurger-module__eU27pW__burger",
  "burgerButton": "HeaderBurger-module__eU27pW__burgerButton",
  "menu": "HeaderBurger-module__eU27pW__menu",
  "menuClose": "HeaderBurger-module__eU27pW__menuClose",
  "menuClosing": "HeaderBurger-module__eU27pW__menuClosing",
  "menuContent": "HeaderBurger-module__eU27pW__menuContent",
  "menuHeader": "HeaderBurger-module__eU27pW__menuHeader",
  "menuIn": "HeaderBurger-module__eU27pW__menuIn",
  "menuOpen": "HeaderBurger-module__eU27pW__menuOpen",
  "menuOut": "HeaderBurger-module__eU27pW__menuOut",
  "overlay": "HeaderBurger-module__eU27pW__overlay",
});
